const WS = (function WS(global) {
    if (global.WebSocket) {
        return global.WebSocket;
    }
    if (global.MozWebSocket) {
        return global.MozWebSocket;
    }
    return global.WebSocket;
})(window);
export default WS;
